// extracted by mini-css-extract-plugin
export default {"wrapper":"TournamentPopup_wrapper__EPonD","title":"TournamentPopup_title__R0cSZ","subTitle":"TournamentPopup_subTitle__usrNk","moreBtn":"TournamentPopup_moreBtn__l82sW"};